import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import {
    setCalendarIntegrationsQuery,
    useUserInfoQuery,
} from '../../lib/Queries';
import * as Toast from '../../lib/Toast.js';
import Modal from '../Modal';
import TextInput from '../TextInput';
import Loading from '../Loading';
import Select from '../Select';
import { getBusinessId } from '../../lib/Api';

const BreelyConnectModal = ({ isModalShowing, onClose }) => {
    const [selectedBusiness, setSelectedBusiness] = useState('');

    const { save, isSaving } = useBusinessPostApi(
        `/integrations/calendars/breely`,
    );

    const { data, isLoading } = useUserInfoQuery();

    const businesses = (data?.businesses || []).filter(
        b => parseInt(b.id) !== parseInt(getBusinessId()),
    );

    const businessOptions = { 0: 'Select a business...' };
    businesses.forEach(business => {
        businessOptions[business.id] = business.name;
    });

    useEffect(() => {
        if (isModalShowing) {
            setSelectedBusiness('');
        }
    }, [isModalShowing]);

    function submit(ev) {
        ev.preventDefault();

        if (!selectedBusiness) {
            return;
        }

        save({
            business: selectedBusiness,
        }).then(result => {
            onClose();
            setCalendarIntegrationsQuery(result);
            Toast.success('Successfully connected Breely account.');
        });
    }

    return (
        <Modal isOpen={isModalShowing} onClose={onClose}>
            <form onSubmit={submit}>
                <div className="mb-4">
                    Connect to another business in Breely to block off times in
                    this business
                </div>

                {isLoading && <Loading />}
                {!isLoading && (
                    <>
                        {businesses.length > 0 && (
                            <Select
                                id="business"
                                label="Business"
                                options={businessOptions}
                                value={selectedBusiness}
                                onChange={setSelectedBusiness}
                            />
                        )}
                        {businesses.length === 0 && (
                            <div className="text-red-600">
                                You have access to 1 business only, there are no
                                other businesses to sync with.
                            </div>
                        )}

                        <button className="btn-save mt-4">
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                    </>
                )}
            </form>
        </Modal>
    );
};

export default BreelyConnectModal;
